import useExportFile from '../useExportFile';

export default function useExportControlModeTemplates() {
  const { exportFile, isExporting, error } = useExportFile({
    endpoint: 'control-mode-templates/export-file',
    entityName: 'Templates',
  });

  const exportTemplates = async (): Promise<boolean> => {
    return exportFile();
  };

  return {
    exportTemplates,
    isExporting,
    error,
  };
}
